import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CuentaContableFormGroup = ({ iError, iTouched, setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    (salida) => {
      setFieldValue('cuentaContable', salida.value)
      setFieldValue('cuentaContableInfo', salida.label)
      KeyEventUtil.leaveOnKeyEvent('input-depreciacionAnual')
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContable', '')
    setFieldValue('cuentaContableInfo', '')
    KeyEventUtil.leaveOnKeyEvent('select-cuentaContable')
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='C. CONTABLE' htmlFor='select-cuentaContable' md={4} alignRightAt='md' />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='cuentaContable' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select-cuentaContable' onlyAnalitica onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
